/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-table[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:20px}.active[_ngcontent-%COMP%]{border-left:5px solid rgba(60,135,132,.5)}.ignore[_ngcontent-%COMP%]{opacity:.3}.failed[_ngcontent-%COMP%]{background-color:rgba(255,0,0,.3)}.mat-row[_ngcontent-%COMP%]:hover{background-color:#eaeaea}"];
export { styles as styles };
